import Button from '@mui/material/Button'
import { useAuth } from 'hooks/use-auth'
import { Typography } from '@mui/material'
import { Modal } from 'Components/Modal'
import { TermsAndConditions } from 'Pages/Login/TermsAndConditions'
import { useEffect, useState } from 'react'
import { sendGet, sendPost } from 'hooks/use-fetch'

export function Login (): JSX.Element {
  window.history.replaceState({}, document.title)

  const { user, loading, login } = useAuth()
  const [showDialog, setShowDialog] = useState(false)

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response, success } = await sendGet('/Account/ShowTermsAndConditions', {})
      if (success) {
        setShowDialog(response)
      }
    }
    void fetchData()
  }, [])

  if (loading) return <></>

  const AgreedToTermsAndConditions = async (): Promise<void> => {
    const { success } = await sendPost('/Account/AgreeToTermsAndConditions', {})
    if (success) {
      setShowDialog(false)
    }
  }

  return (
    <>
      {(user?.noActiveISDs === true) && (
        <Typography sx={{ color: 'red' }} data-testid='inactiveISDnotification'>The ISD(s) tied to this account are not active.  Because of that you no longer have access to MiECC.</Typography>
      )}
      {(user?.noAccount === true || user?.inactive === true) && !(user?.noActiveISDs ?? false) && (
        <Typography sx={{ color: 'red' }}>This account is not authorized for MiECC.</Typography>
      )}
      {(user == null) &&
        <Button
          sx={{ textTransform: 'none' }}
          onClick={() => { login() }}
          variant="contained"
          autoCapitalize="false"
        >
          Login
        </Button>
      }

      <Modal
        open={showDialog}
        title='Terms and Conditions'
        confirmationContent={<TermsAndConditions />}
        hideCancelButton={true}
        confirmButtonText='I Agree'
        onConfirm={AgreedToTermsAndConditions}
        onClose={function (): void {
          setShowDialog(false)
        }}
      />
    </>
  )
}
